(function($) {
	


	$('a[href="#video-play"]').on('click', function(event) {
		event.preventDefault();

		var $video = $(this).closest('section').find('video');
		$video.get(0).play();
		
		var pause = $(this).closest('section').find('.controls .pause');
		pause.show();
		$(this).hide();
	});

	$('a[href="#video-pause"]').on('click', function(event) {
		event.preventDefault();

		var $video = $(this).closest('section').find('video');
		console.log( $video );
		$video.get(0).pause();

		var play = $(this).closest('section').find('.controls .play');
		play.show();
		$(this).hide();
	});

	// vimeo play\pause controls
	const vimeoIframeEl = document.getElementById('vimeo-video');

	if(vimeoIframeEl && window.Vimeo){

		const player = new Vimeo.Player(vimeoIframeEl);

        player.setVolume(0);

        $('a[href="#vimeo-play"]').on('click', function(event) {
            event.preventDefault();

            const $btn = $(this),
            	  $pauseBtn = $(this).closest('section').find('.controls .pause');
            player.play();
            $pauseBtn.show();
            $btn.hide();
        });

        $('a[href="#vimeo-pause"]').on('click', function(event) {

        	event.preventDefault();

            const $btn = $(this),
				  $playBtn = $btn.closest('section').find('.controls .play');

            player.pause();

            $playBtn.show();

            $btn.hide();

        });
        // player.on('play', function() {
        //     console.log('played the video!');
        // });
        //
        // player.on('pause', function() {
        //     console.log('played the video!');
        // });

    }



})(jQuery);